import { useCallback } from "react";

import {
    SortDirection,
    TableControls,
    UseFastshiftTableControls
} from "../../types";

export const useFastshiftTableControls: UseFastshiftTableControls = ({
    pagination,
    controls,
    onSetControlsPayload
}: TableControls) => {
    // Local state
    const searchTerm = controls?.searchTerm || "";

    const onClickNext = useCallback(() => {
        onSetControlsPayload({
            ...controls,
            page: pagination.page + 1
        });
    }, [onSetControlsPayload, pagination.page, controls]);

    const onClickPrevious = useCallback(() => {
        onSetControlsPayload({
            ...controls,
            page: pagination.page - 1
        });
    }, [onSetControlsPayload, pagination.page, controls]);

    const onSizeChange = useCallback(
        (size: number) => {
            onSetControlsPayload({
                ...controls,
                page: 0,
                size
            });
        },
        [onSetControlsPayload, controls]
    );

    const onSort = useCallback(
        (key: string, order?: SortDirection) => {
            onSetControlsPayload({
                ...controls,
                page: 0,
                sortBy: key,
                sortDirection: order
            });
        },
        [onSetControlsPayload, controls]
    );

    const onSetSearchTerm = useCallback(
        (searchTerm: string) => {
            onSetControlsPayload({
                ...controls,
                page: 0,
                searchTerm
            });
        },
        [onSetControlsPayload, controls]
    );

    return {
        pagination: {
            onClickNext,
            onClickPrevious,
            onSizeChange: onSizeChange,
            ...pagination
        },
        sorting: {
            onSort,
            sortBy: controls?.sortBy,
            sortDirection: controls?.sortDirection
        },
        search: {
            onSetSearchTerm,
            searchTerm
        }
    };
};
